import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { fadeAnimation } from '../core/animation/fade-animations';
import { toBoolean } from '../util/convert';

@Component({
  selector     : 'nz-alert',
  encapsulation: ViewEncapsulation.None,
  animations   : [ fadeAnimation ],
  template     : `
    <div [ngClass]="_classMap" *ngIf="_display" [@fadeAnimation]>
      <i
        class="ant-alert-icon anticon"
        [class.anticon-cross-circle-o]="nzType==='error'"
        [class.anticon-check-circle-o]="nzType==='success'"
        [class.anticon-info-circle-o]="nzType==='info'"
        [class.anticon-exclamation-circle-o]="nzType==='warning'"
        *ngIf="nzShowIcon&&nzDescription"></i>
      <i
        class="ant-alert-icon anticon"
        [class.anticon-cross-circle]="nzType==='error'"
        [class.anticon-check-circle]="nzType==='success'"
        [class.anticon-info-circle]="nzType==='info'"
        [class.anticon-exclamation-circle]="nzType==='warning'"
        *ngIf="nzShowIcon&&!nzDescription"></i>
      <ng-template [ngIf]="nzMessage">
        <span class="ant-alert-message">{{ nzMessage }}</span>
      </ng-template>
      <ng-template [ngIf]="!nzMessage">
        <ng-content select="[alert-body]"></ng-content>
      </ng-template>
      <ng-template [ngIf]="nzDescription">
        <span class="ant-alert-description">{{ nzDescription }}</span>
      </ng-template>
      <ng-template [ngIf]="!nzDescription">
        <ng-content select="alert-description"></ng-content>
      </ng-template>
      <ng-template [ngIf]="nzCloseable || nzCloseText">
        <a *ngIf="nzCloseable" (click)="closeAlert($event)" class="ant-alert-close-icon">
          <i class="anticon anticon-cross"></i>
        </a>
        <a *ngIf="nzCloseText" class="ant-alert-close-icon" (click)="closeAlert()">{{ nzCloseText }}</a>
      </ng-template>
    </div>
  `,
  styles: [
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-alert {
  position: relative;
  padding: 8px 48px 8px 38px;
  border-radius: 4px;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}
.ant-alert.ant-alert-no-icon {
  padding: 8px 48px 8px 16px;
}
.ant-alert-icon {
  font-size: 16px;
  top: 10.5px;
  left: 16px;
  position: absolute;
}
.ant-alert-description {
  font-size: 14px;
  line-height: 21px;
  display: none;
}
.ant-alert-success {
  border: 1px solid #cfefdf;
  background-color: #ebf8f2;
}
.ant-alert-success .ant-alert-icon {
  color: #00a854;
}
.ant-alert-info {
  border: 1px solid #cff2ef;
  background-color: #ebf9f8;
}
.ant-alert-info .ant-alert-icon {
  color: #108ee9;
}
.ant-alert-warning {
  border: 1px solid #fff3cf;
  background-color: #fffaeb;
}
.ant-alert-warning .ant-alert-icon {
  color: #ffbf00;
}
.ant-alert-error {
  border: 1px solid #fcdbd9;
  background-color: #fef0ef;
}
.ant-alert-error .ant-alert-icon {
  color: #f04134;
}
.ant-alert-close-icon {
  font-size: 14px;
  position: absolute;
  right: 16px;
  top: 10px;
  height: 12px;
  line-height: 12px;
  overflow: hidden;
  cursor: pointer;
}
.ant-alert-close-icon .anticon-cross {
  color: rgba(0, 0, 0, 0.43);
  transition: color .3s ease;
}
.ant-alert-close-icon .anticon-cross:hover {
  color: #404040;
}
.ant-alert-close-text {
  position: absolute;
  right: 16px;
}
.ant-alert-with-description {
  padding: 16px 16px 16px 60px;
  position: relative;
  border-radius: 4px;
  color: #666;
  line-height: 1.5;
}
.ant-alert-with-description.ant-alert-no-icon {
  padding: 16px;
}
.ant-alert-with-description .ant-alert-icon {
  position: absolute;
  top: 16px;
  left: 20px;
  font-size: 24px;
}
.ant-alert-with-description .ant-alert-close-icon {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  font-size: 14px;
}
.ant-alert-with-description .ant-alert-message {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  display: block;
  margin-bottom: 4px;
}
.ant-alert-with-description .ant-alert-description {
  display: block;
}
.ant-alert.ant-alert-close {
  height: 0 !important;
  margin: 0;
  padding-top: 0;
  padding-bottom: 0;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  transform-origin: 50% 0;
}
.ant-alert-slide-up-leave {
  animation: antAlertSlideUpOut 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  animation-fill-mode: both;
}
.ant-alert-banner {
  border-radius: 0;
  border: 0;
  margin-bottom: 0;
}
@keyframes antAlertSlideUpIn {
  0% {
    opacity: 0;
    transform-origin: 0% 0%;
    transform: scaleY(0);
  }
  100% {
    opacity: 1;
    transform-origin: 0% 0%;
    transform: scaleY(1);
  }
}
@keyframes antAlertSlideUpOut {
  0% {
    opacity: 1;
    transform-origin: 0% 0%;
    transform: scaleY(1);
  }
  100% {
    opacity: 0;
    transform-origin: 0% 0%;
    transform: scaleY(0);
  }
}
`,
    `nz-alert {
  display: block;
}
`
  ]
})
export class NzAlertComponent implements OnChanges {
  private _banner = false;
  private _closeable = false;
  private _showIcon = false;
  _display = true;
  antAlert = 'ant-alert';
  @Input() nzType = 'info';
  @Input() nzDescription: string;
  @Input() nzCloseText: string;
  @Input() nzMessage: string;
  @Output() nzOnClose: EventEmitter<boolean> = new EventEmitter();

  @Input()
  set nzBanner(value: boolean) {
    this._banner = toBoolean(value);
  }

  get nzBanner(): boolean {
    return this._banner;
  }

  @Input()
  set nzCloseable(value: boolean) {
    this._closeable = toBoolean(value);
  }

  get nzCloseable(): boolean {
    return this._closeable;
  }

  @Input()
  set nzShowIcon(value: boolean) {
    this._showIcon = toBoolean(value);
  }

  get nzShowIcon(): boolean {
    return this._showIcon;
  }

  _classMap = {
    [`${this.antAlert}`]                 : true,
    [`${this.antAlert}-${this.nzType}`]  : true,
    [`${this.antAlert}-no-icon`]         : !this.nzShowIcon,
    [`${this.antAlert}-banner`]          : this.nzBanner,
    [`${this.antAlert}-with-description`]: !!this.nzDescription
  };

  closeAlert(): void {
    this._display = false;
    this.nzOnClose.emit(true);
  }

  ngOnChanges(): void {
    this._classMap = {
      [`${this.antAlert}`]                 : true,
      [`${this.antAlert}-${this.nzType}`]  : true,
      [`${this.antAlert}-no-icon`]         : !this.nzShowIcon,
      [`${this.antAlert}-banner`]          : this.nzBanner,
      [`${this.antAlert}-with-description`]: !!this.nzDescription
    };
  }
}
